import React from 'react';
import { connect } from "react-redux";
import getCustomerList from "../../actions/getCustomerList";
import showLogin from "../../actions/showLogin";
import getAuditReport from "../../actions/getAuditReport";
import getReport from "../../actions/getReport";
import MainLayout from "../Layout/Layout";
import { Button, Empty, Form, Table, Typography } from 'antd';
import { DownloadOutlined } from "@ant-design/icons";
import { CustomerFilterItem, DateRangeFilterItem, ReportFilterActions, ReportFilterHeader } from "../ReportFilters/ReportFilters";

/**
 * Función utilitaria para extraer valores de propiedades de forma defensiva,
 * probando múltiples variaciones de nombres de atributos.
 */
const getPropertyValue = (record, possibleKeys) => {
    for (const key of possibleKeys) {
        if (record && record[key] !== undefined && record[key] !== null) {
            return String(record[key]);
        }
    }
    return '';
};

// Columnas definidas con renderizado de datos defensivo
const columns = [
    {
        title: 'Fecha',
        key: 'fecha',
        render: (text, record) => getPropertyValue(record, ['fecha', 'date', 'createdAt', 'creationDate', 'timestamp'])
    },
    {
        title: 'Usuario',
        key: 'usuario',
        render: (text, record) => getPropertyValue(record, ['usuario', 'user', 'username', 'email', 'login', 'name'])
    },
    {
        title: 'Acción / Operación',
        key: 'accion',
        render: (text, record) => getPropertyValue(record, ['accion', 'action', 'operation', 'type', 'description'])
    },
    {
        title: 'Estado',
        key: 'estado',
        render: (text, record) => getPropertyValue(record, ['estado', 'status', 'state', 'result'])
    }
];

class AuditReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searched: false,
            lastSearchValues: null
        };
    }

    componentDidMount() {
        if (!this.props.login.tokenId || !this.props.login.profileObj) {
            this.props.showLogin();
        }
        this.props.getCustomerList();
    }

    handleSearch = (formValues) => {
        this.setState({ searched: true, lastSearchValues: formValues });
        this.props.getAuditReport(formValues);
    };

    handleExport = () => {
        if (this.state.lastSearchValues) {
            this.props.getReport("getAuditReport", "reporte_auditoria.csv", this.state.lastSearchValues);
        }
    };

    render() {
        return (
            <MainLayout title={'logo'} size={'medium'} variant="report"
                        reportTitle="Auditoría de Eventos"
                        reportDescription="Consulta eventos, movimientos y acciones realizadas por usuarios para validaciones operativas.">
                <Form
                    className="report-filter-panel"
                    layout="vertical"
                    name="auditReport"
                    onFinish={this.handleSearch}
                >
                    <ReportFilterHeader/>
                    <div className="report-filter-fields">
                        <CustomerFilterItem customerList={this.props.customerList}/>
                        <DateRangeFilterItem/>
                    </div>
                    <ReportFilterActions>Consultar</ReportFilterActions>
                </Form>

                {this.props.reportData && this.props.reportData.length > 0 ? (
                    <div className="report-result-panel">
                        <div className="report-result-header">
                            <div className="report-result-heading">
                                <Typography.Title level={3}>Resultados de Auditoría</Typography.Title>
                                <Typography.Text className="report-result-count">
                                    {this.props.reportData.length} registros encontrados
                                </Typography.Text>
                            </div>
                            <Button
                                className="report-download-button"
                                icon={<DownloadOutlined />}
                                onClick={this.handleExport}
                            >
                                Descargar CSV
                            </Button>
                        </div>
                        <div className="report-table-shell">
                            <div className="report-table-scroll-hint">Desliza horizontalmente para ver más columnas</div>
                            <Table
                                dataSource={this.props.reportData}
                                columns={columns}
                                rowKey={(record, index) => record.id || record.key || index}
                                pagination={{ pageSize: 10, showSizeChanger: false }}
                                scroll={{ x: 720 }}
                                size="middle"
                                tableLayout="fixed"
                                className="report-result-table"
                            />
                        </div>
                    </div>
                ) : (
                    this.state.searched && (
                        <div className="report-result-panel">
                            <Empty description="No se encontraron resultados para los filtros seleccionados."/>
                        </div>
                    )
                )}
            </MainLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        login: state.login,
        customerList: state.customer.customerList,
        reportData: state.audit.reportData
    };
}

export default connect(mapStateToProps, { getCustomerList, showLogin, getAuditReport, getReport })(AuditReport);
